// Только для идемпотентных запросов: повторяем при таймауте или обрыве сети,
// ответ сервера с ошибкой не повторяем
export const retryOnNetworkError = async <T>(request: () => Promise<T>): Promise<T> => {
  try {
    return await request()
  } catch (e: any) {
    if (e?.response || !e?.config) {
      throw e
    }
    return request()
  }
}
